<template>
  <div class="address-container">
    <div class="address-list">
      <div class="selected-address">
        <div class="address">{{ selectedAddress?.addressAll || selectedAddress?.receiverAddress || '--' }}</div>
        <div class="name-phone">
          <div class="name">{{ selectedAddress?.contact || selectedAddress?.receiverName || '--' }}</div>
          <div class="phone">{{ selectedAddress?.contactNumber || selectedAddress?.receiverPhone || '--' }}</div>
        </div>
      </div>
      <div class="operation" v-if="!waitPay">
        <es-button
          variant="text"
          theme="primary"
          v-if="addresses.length"
          size="small"
          class="select-other-address"
          @click="selectAddressDialogVisible = true">
          <img class="select-icon" src="@/assets/icons/selectIcon.svg" :alt="$t('选择其他地址')" />
          <span>{{ $t('选择其他地址') }}</span>
        </es-button>
        <es-button class="select-other-address" variant="text" theme="primary" size="small" @click="openAddAddressDialog">
          <img class="select-icon" src="@/assets/icons/add-icon.svg" :alt="addresses.length ? $t('使用新地址') : $t('新建地址')" />
          <span>{{ addresses.length ? $t('使用新地址') : $t('新建地址') }}</span>
        </es-button>
      </div>
    </div>
    <AddressSelectDialog
      :visible.sync="selectAddressDialogVisible"
      :addresses="addresses"
      @close="selectAddressDialogVisible = false"
      @submit="selectAddress"
      @addAddress="openAddAddressDialog"
      :defaultChoosedAdd="choosedAdd" />
    <AddAddressDialog v-if="dialogVisible" :visible.sync="dialogVisible" @close="dialogVisible = false" @submit="onSubmit" />
  </div>
</template>
<script>
import AddressSelectDialog from './addressSelectDialog.vue'
import AddAddressDialog from './addAddressDialog.vue'
export default {
  name: 'Address',
  components: {
    AddressSelectDialog,
    AddAddressDialog,
  },
  props: {
    showAddress: {
      type: Array,
      default: () => [],
    },
    waitPay: {
      type: Boolean,
      default: false,
    },
    addressInfo: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      addresses: [],
      showAll: false,
      choosedAdd: '',
      selectAddressDialogVisible: false,
    }
  },
  computed: {
    selectedAddress() {
      return this.addressInfo || this.addresses.find(item => item.addressId === this.choosedAdd)
    },
  },
  methods: {
    openAddAddressDialog() {
      this.dialogVisible = true
    },
    selectAddress(addressId) {
      this.choosedAdd = addressId
      this.selectAddressDialogVisible = false
    },
    onSubmit(addressId) {
      this.getAddress(addressId)
      this.dialogVisible = false
    },
    getAddress(choosedAdd) {
      this.$ajax(this.$url.getExpressAddress(), {
        offset: 0,
        size: 1000,
      }).then(res => {
        this.addresses = res.data.addresses || []
        if (this.addresses.length > 0) {
          this.choosedAdd = choosedAdd || this.addresses[0].addressId
        }
      })
    },
  },
  watch: {
    choosedAdd(val) {
      const address = this.addresses.filter(item => item.addressId === val)[0]
      const data = {
        receiverAddress: address.addressAll,
        receiverName: address.contact,
        receiverPhone: address.contactNumber,
      }
      this.$emit('getVal', data)
    },
  },
  created() {
    this.getAddress()
  },
}
</script>
<style lang="less" scoped>
.address-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 14px 20px;
  border: 1px solid #e5e6eb;
  border-radius: 8px;
}
.selected-address {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .address {
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: #333333;
    margin-bottom: 8px;
  }
  .name-phone {
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: #999999;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .name {
      margin-right: 4px;
    }
  }
}
.operation {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 8px;
  .select-other-address {
    margin-right: 8px;
    /deep/ span {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
  .select-icon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }
}
</style>
